module.exports = __webpack_public_path__ + "img/facebook.d82ef086.svg";